import { NgModule } from '@angular/core';
import { ColorBendsBackgroundComponent } from './color-bends-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        ColorBendsBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ColorBendsBackgroundComponent
    ]
})
export class NcColorBendsBackgroundModule { }